var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0833 13.5417C26.0833 16.0222 25.3478 18.447 23.9697 20.5094C22.5916 22.5719 20.6329 24.1794 18.3412 25.1287C16.0495 26.0779 13.5278 26.3263 11.0949 25.8423C8.66207 25.3584 6.42736 24.1639 4.67337 22.41C2.91939 20.656 1.72491 18.4213 1.24099 15.9884C0.757067 13.5556 1.00543 11.0339 1.95468 8.74218C2.90393 6.45049 4.51143 4.49175 6.5739 3.11365C8.63636 1.73556 11.0612 1 13.5417 1M22.5915 4.49183L12.7769 17.8513L6.44367 12.5494",
    stroke: "#1AC987",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSuccess);
export default __webpack_public_path__ + "static/media/tick-success.ec91f828d133e787392ab71de0e0018e.svg";
export { ForwardRef as ReactComponent };